/**
 *
 * TeamModal
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Divider, Select, Button, Table, Input, Tooltip, Spin } from "antd"
import { get, truncate, filter, map, uniqBy } from "lodash"
import ModalCustom from "../ModalCustom"
import removeIcon from "../../images/remove_icon.svg"
import userIcon from "../../images/user_icon.svg"
import addIcon from "../../images/add_icon.svg"
import "./styles.less"
import {
  PlusOutlined,
  CloseOutlined,
  SearchOutlined,
  LeftOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons"
import { LOCAL_VISMA_PEOPLE_SYNC_ENABLED } from "../../utils/storage"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
class TeamModal extends React.Component {
  state = {
    showListCollaborators: false,
    collaborators: [],
    employeeSelected: undefined,
    employeesSelected: [],
    inputSearchTeamPotential: "",
    teamPotentialState: [],
    inputTeam: "",
  }

  componentDidMount = () => {
    this.setState({
      collaborators: this.props.collaboratorTeam,
      teamPotentialState: this.props.teamPotential,
    })
  }

  componentWillUnmount = () => {
    this.setState({
      teamPotentialState: [],
      collaborators: [],
    })
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      !(
        prevProps.collaboratorTeam.length === this.props.collaboratorTeam.length
      )
    ) {
      this.setState({ collaborators: this.props.collaboratorTeam })
    }

    if (!(prevProps.teamPotential.length === this.props.teamPotential.length)) {
      this.setState({ teamPotentialState: this.props.teamPotential })
    }
  }

  handleFilterListChange = (value) => {
    this.setState({
      inputSearchTeamPotential: value,
      teamPotentialState: filter(this.props.teamPotential, (item) => {
        return (
          item.full_name.toLowerCase().includes(value.toLowerCase()) ||
          item.division_name.toLowerCase().includes(value.toLowerCase()) ||
          item.position_name.toLowerCase().includes(value.toLowerCase())
        )
      }),
    })
  }

  handleFilterListSelect = (value) => {
    if (!value) {
      return this.setState({ teamPotentialState: this.props.teamPotential })
    }

    this.setState({
      teamPotentialState: filter(this.props.teamPotential, (item) =>
        item.division_name.toLowerCase().includes(value.toLowerCase())
      ),
    })
  }

  handleFilterCollaboratorsChange = (value) => {
    if (!value) {
      return this.setState({
        inputTeam: "",
        collaborators: this.props.collaboratorTeam,
      })
    }

    this.setState({
      inputTeam: value,
      collaborators: filter(this.props.collaboratorTeam, (item) => {
        return (
          item.full_name.toLowerCase().includes(value.toLowerCase()) ||
          item.position_name.toLowerCase().includes(value.toLowerCase())
        )
      }),
    })
  }

  handleStateClick = (name, value) => {
    this.setState({ [name]: value })
  }

  handleAddEmployeesClick = (idEmployees = this.state.employeeSelected) => {
    let search_data= {
      ...this.props.paginationRecord,
      leaders: this.props.leadersSelected,
      divisions: this.props.divisionsSelected,
      segments: this.props.segmentsSelected
    }
    const params = {
      idCollaborator: this.props.collaboratorSelected.id_employee,
      search_data: search_data
    }

    if (!Array.isArray(idEmployees)) {
      params.payload = `id_employee[0]=${idEmployees}`
    } else {
      params.payload = map(
        idEmployees,
        (item, index) => `id_employee[${index}]=${item}`
      ).join("&")
    }

    this.setState({ employeesSelected: [] })
    this.props.addEmployeesTeamWatcher(params)
  }

  handleRemoveEmployeesclick = (idEmployees) => {
    let search_data= {
      ...this.props.paginationRecord,
      leaders: this.props.leadersSelected,
      divisions: this.props.divisionsSelected,
      segments: this.props.segmentsSelected
    }
    const params = { idLeader: this.props.collaboratorSelected.id_employee,search_data: search_data }

    if (!Array.isArray(idEmployees)) {
      params.payload = `id_employee[0]=${idEmployees}`
    }

    this.props.removeEmployeesTeamWatcher(params)
  }

  showTotal = (total, range) => (
    <span
      style={{
        color: "#A6A6A6",
      }}>{`Total colaboradores sin líder: ${total}`}</span>
  )

  render() {
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ employeesSelected: selectedRowKeys })
      },
      onSelect: (record, selected, selectedRows) => {},
      onSelectAll: (selected, selectedRows, changeRows) => {},
      selectedRowKeys: this.state.employeesSelected,
    }

    const columnsListCollaborators = [
      {
        title: "Colaborador",
        dataIndex: "full_name",
        key: "full_name",
        width: 230,
        sorter: (a, b) => a.full_name.localeCompare(b.full_name),
        render: (text) => truncate(text, { length: 28 }),
      },
      {
        title: "Puesto",
        width: 200,
        dataIndex: "position_name",
        key: "position_name",
        render: (text) => truncate(text, { length: 24 }),
      },
      {
        title: "Área",
        dataIndex: "division_name",
        key: "division_name",
        render: (text, record) => {
          return (
            <div className="column-division-name">
              <span>{truncate(text, { length: 30 })}</span>
              <Tooltip placement="top" title="Agregar">
                <img
                  src={addIcon}
                  onClick={() =>
                    this.handleAddEmployeesClick(record.id_employee)
                  }
                />
              </Tooltip>
            </div>
          )
        },
      },
    ]

    const columnsCollaborators = [
      {
        title: "Colaborador",
        dataIndex: "full_name",
        key: "full_name",
        width: 260,
        sorter: (a, b) => a.full_name.localeCompare(b.full_name),
        render: (text, record) => {
          return (
            <div>
              <img
                style={{
                  borderRadius: "50%",
                  width: 26,
                  height: 26,
                  marginRight: 10,
                }}
                src={record.picture_profile}
              />
              <span>{truncate(text, { length: 28 })}</span>
            </div>
          )
        },
      },
      {
        title: "Puesto",
        dataIndex: "position_name",
        key: "position_name",
        render: (text, record) => {
          return (
            <div className="column-position-team">
              <span>{truncate(text, { length: 38 })}</span>
              {!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && (
                <div className="column-position-team-actions">
                  <img src={userIcon} />
                  <img
                    src={removeIcon}
                    onClick={() => {
                      this.handleRemoveEmployeesclick(record.id_employee)
                    }}
                  />
                </div>
              )}
            </div>
          )
        },
      },
    ]

    return (
      <ModalCustom
        width={this.state.showListCollaborators ? 780 : 647}
        modalOpen={this.props.modalOpen}
        textAlign="left"
        showOnlyCancel
        textCancelButton="Cerrar"
        // onOk={() => {
        //   this.props.openModalOf('modalTeam', false, {})
        //   this.handleStateClick('showListCollaborators', false)
        // }}
        onCancel={() => {
          this.props.openModalOf("modalTeam", false, {})
          this.handleStateClick("showListCollaborators", false)
        }}
        title={
          <div className="team-modal-title">
            Equipo de{" "}
            <span>
              {get(this.props.collaboratorSelected, "full_name", "Anonymous")}
            </span>
          </div>
        }>
        {!this.state.showListCollaborators && (
          <div>
            {!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && (
              <>
                <p>
                  Busca y selecciona los colaboradores que deseas agregar al equipo:
                </p>
                <div className="team-modal-select-collaborator">
                  <div>
                    <Spin
                      spinning={this.props.isLoadingTeamPotential}
                      className="team-modal-select-spin">
                      <Select
                        allowClear
                        showSearch
                        value={this.state.employeeSelected}
                        onChange={(e) =>
                          this.handleStateClick("employeeSelected", e)
                        }
                        placeholder="Buscar..."
                        className="team-modal-search-collaborator"
                        filterOption={(input, option) => {
                          return (
                            option.props.children.props.title
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          )
                        }}>
                        {Array.isArray(this.props.teamPotential) &&
                          map(this.props.teamPotential, (item) => {
                            return (
                              <Option
                                key={item.id_employee}
                                value={item.id_employee}>
                                <Tooltip title={item.full_name}>
                                  {item.full_name}
                                </Tooltip>
                              </Option>
                            )
                          })}
                      </Select>
                    </Spin>
                    <Button
                      disabled={!this.state.employeeSelected}
                      type="primary"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: 13,
                      }}
                      icon={<PlusOutlined />}
                      onClick={() => {
                        this.handleStateClick("employeeSelected", undefined)
                        this.props.setStateFromCollaborators("inputSearch", "")
                        this.handleAddEmployeesClick()
                      }}>
                      <span style={{ fontSize: 14 }}>Agregar</span>
                    </Button>
                  </div>
                  <Button
                    onClick={() =>
                      this.handleStateClick("showListCollaborators", true)
                    }>
                    Ver listado
                  </Button>
                </div>
                <Divider style={{ marginBottom: 12 }} />
              </>
            )}
            <div className="team-modal-header-table">
              <span>
                {this.props.collaboratorTeam.length}{" "}
                {this.props.collaboratorTeam.length === 1
                  ? "colaborador"
                  : "colaboradores"}
              </span>
              <Input
                value={this.state.inputTeam}
                onChange={(e) =>
                  this.handleFilterCollaboratorsChange(e.target.value)
                }
                placeholder="Buscar..."
                suffix={
                  this.state.inputTeam ? (
                    <CloseOutlined
                      style={{
                        cursor: "pointer",
                        color: "white",
                        background: "rgba(0, 0, 0, 0.25)",
                        borderRadius: "50%",
                      }}
                      onClick={() => this.handleFilterCollaboratorsChange("")}
                    />
                  ) : (
                    <SearchOutlined type="search" />
                  )
                }
              />
            </div>
            <Table
              rowKey={(record) => record.id_employee}
              className="team-modal-table"
              columns={columnsCollaborators}
              loading={this.props.isLoadingCollaboratorTeam}
              dataSource={this.state.collaborators}
              pagination={false}
              scroll={{ y: 160 }}
            />
          </div>
        )}
        {/* LIST OF WITHOUT LEADER */}
        {this.state.showListCollaborators && (
          <div>
            <div className="team-modal-list-header">
              <span
                onClick={() => {
                  this.handleStateClick("showListCollaborators", false)
                  this.setState({ employeesSelected: [] })
                }}>
                <LeftOutlined />
                Equipo de{" "}
                {truncate(
                  get(
                    this.props.collaboratorSelected,
                    "full_name",
                    "Anonymous"
                  ),
                  { length: 26 }
                )}
              </span>
              <div className="team-modal-list-header-right">
                <Select
                  allowClear
                  showSearch
                  placeholder="Seleccionar división"
                  onChange={this.handleFilterListSelect}>
                  {map(
                    uniqBy(this.props.teamPotential, "division_name"),
                    (item) => {
                      return (
                        <Option
                          key={item.division_name}
                          value={item.division_name}>
                          <Tooltip title={item.division_name}>
                            {item.division_name}
                          </Tooltip>
                        </Option>
                      )
                    }
                  )}
                </Select>
                <Input
                  value={this.state.inputSearchTeamPotential}
                  placeholder="Buscar..."
                  onChange={(e) => this.handleFilterListChange(e.target.value)}
                  suffix={
                    this.state.inputSearchTeamPotential ? (
                      <CloseCircleOutlined
                        style={{
                          cursor: "pointer",
                          color: "white",
                          background: "rgba(0, 0, 0, 0.25)",
                          borderRadius: "50%",
                        }}
                        onClick={() => this.handleFilterListChange("")}
                      />
                    ) : (
                      <SearchOutlined />
                    )
                  }
                />
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  disabled={!this.state.employeesSelected.length}
                  className="add-second-button"
                  onClick={() =>
                    this.handleAddEmployeesClick(this.state.employeesSelected)
                  }>
                  Agregar
                </Button>
              </div>
            </div>
            <Table
              scroll={{ y: 360 }}
              rowSelection={rowSelection}
              rowKey={(record) => record.id_employee}
              className="team-modal-table"
              columns={columnsListCollaborators}
              loading={this.props.isLoadingTeamPotential}
              dataSource={this.state.teamPotentialState}
              pagination={{
                // pageSizeOptions: ['15', '25', '50', '100'],
                showSizeChanger: false,
                size: "default",
                defaultPageSize: 8,
                showTotal: this.showTotal,
              }}
            />
          </div>
        )}
      </ModalCustom>
    )
  }
}

TeamModal.propTypes = {}

export default TeamModal
